<template>
  <!-- <v-container> -->
    <v-card max-width="400" class="mx-auto d-block">
      <v-card-title class="py-2 my-0">
        <v-row justify="center">
          <v-col cols="9">
            <v-text-field
              label="Add a note"
              outlined
              v-model="newNote"
              id="note-input"
              :error-messages="imageError.notes"
              @keydown.enter="addNote"
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-btn
              color="primary"
              small
              fab
              @click="addNote"
              id="add-note-btn"
            >
              <v-icon>add</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider></v-divider>
      <v-virtual-scroll
        :items="notes"
        :item-height="50"
        height="250"
      >
        <template v-slot="{ item, index }">
          <v-list-item>
            <v-list-item-content>
              {{item}}
            </v-list-item-content>
            <v-list-item-action>
              <v-btn icon @click="deleteNote(index)">
                <v-icon>delete</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
        </template>
      </v-virtual-scroll>
    </v-card>
  <!-- </v-container> -->
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ImageEditForm',
  props: ['image', 'type'],
  data: () => ({
    newNote: '',
    notes: [],
    model: [],
    error: {
      message: '',
    },
  }),
  methods: {
    ...mapActions(['updateImage', 'setCurrentImage', 'setNotification', 'setImageError']),
    async addNote() {
      const error = { ...this.imageError };
      if (this.newNote.length !== 0) {
        const currentImage = { ...this.image };
        const { length } = currentImage.process_tracking;
        this.notes.push(this.newNote);
        const updateData = {
          companyId: currentImage.companyId,
          project_id: currentImage.project_id,
          user_id: currentImage.user_id,
          filename: currentImage.filename,
          date: currentImage.date,
          update: {},
        };
        if (this.type === 'original') updateData.update.notes = this.notes;
        else {
          updateData.update.process_tracking = currentImage.process_tracking;
          updateData.update.process_tracking[length - 1].notes = this.notes;
        }

        const response = await this.updateImage(updateData);
        if (response.status === 200) {
          const { filename } = response.data;
          this.setCurrentImage(response.data);

          const imageType = (this.type === 'original') ? 'image' : 'processed image';
          this.setNotification({ success: true, message: `You have successfully added a note to the ${imageType} with file name: ${filename}` });
          this.newNote = '';
          if (this.imageError.notes) {
            error.notes = '';
            this.setImageError(error);
          }
        }
      } else {
        error.notes = 'You may not submit an empty text as a note.';
        this.setImageError(error);
      }
    },
    async deleteNote(index) {
      const currentImage = { ...this.image };
      const { length } = currentImage.process_tracking;
      const removedNote = this.notes.splice(index, 1);
      const updateData = {
        companyId: currentImage.companyId,
        project_id: currentImage.project_id,
        filename: currentImage.filename,
        date: currentImage.date,
        user_id: currentImage.user_id,
        update: {},
      };

      if (this.type === 'original') updateData.update.notes = this.notes;
      else {
        updateData.update.process_tracking = currentImage.process_tracking;
        updateData.update.process_tracking[length - 1].notes = this.notes;
      }

      const response = await this.updateImage(updateData);
      if (response.status === 200) {
        this.setCurrentImage(response.data);
        const { filename } = response.data;
        const imageType = (this.type === 'original') ? 'image' : 'processed image';

        this.setNotification({
          success: true,
          message: `You have successfully removed the note "${removedNote}" from ${imageType} with file name ${filename}`,
        });
      }
    },
  },
  computed: {
    ...mapGetters(['imageError']),
  },
  mounted() {
    const img = { ...this.image };
    if (this.type === 'ai') img.process_tracking[0].notes = Object.keys(img.process_tracking[0]).includes('notes') ? img.process_tracking[0].notes : [];
    if (this.type === 'original') {
      this.notes = img.notes ? img.notes : [];
    } else {
      this.notes = img.process_tracking[0].notes;
    }
  },
  watch: {
    image(newValue) {
      const img = { ...newValue };
      if (this.type === 'ai') img.process_tracking[0].notes = Object.keys(img.process_tracking[0]).includes('notes') ? img.process_tracking[0].notes : [];
      if (this.type === 'original') {
        this.notes = img.notes ? img.notes : [];
      } else {
        this.notes = img.process_tracking[0].notes;
      }
    },
  },
};
</script>
